import { useEffect, useState } from "react";
import Loader from "@element/Loader/Loader";
import { apiRequest } from "@utils/service";
import Default from "@layout/Default/Default";

interface Payment {
  subject_name: string;
  exam_name: string;
  group_name: string;
  payment_amount: string;
  months: string;
  timestamp: string;
}
const Payments = () => {
  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState<Payment[]>([]);

  useEffect(() => {
    setLoading(true);
    apiRequest("payments_list")
      .then((resp) => {
        if (resp.success === "true") {
          setPayments(resp.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Default>
      {loading && <Loader />}
      <div className="d-flex justify-content-center">
        <div className="card">
          <div className="card-header">
            <h3>Payments</h3>
          </div>
          <div className="card-body">
            <div className="d-flex flex-column gap-4">
              {payments.map((payment) => (
                <div
                  key={payment.timestamp}
                  className="d-flex gap-2 border p-2"
                >
                  <div className="d-flex justify-content-center align-items-center border p-2">
                    {Intl.DateTimeFormat("en-IN", {
                      dateStyle: "medium",
                    }).format(new Date(payment.timestamp))}
                  </div>
                  <div className="w-100">
                    <h6 className="text-start">{payment.subject_name}</h6>
                    <div className="d-flex mt-2 justify-content-between">
                      <small>{payment.group_name}</small>
                      <small>{payment.months} Months</small>
                      <h5>
                        {Intl.NumberFormat("en-IN", {
                          currency: "INR",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          style: "currency",
                        }).format(Number(payment.payment_amount))}
                      </h5>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Default>
  );
};

export default Payments;
